import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Retour « intelligent » : revient à la page précédente quand on est arrivé par
 * la navigation de l'application, sinon va sur `fallback`.
 *
 * Pourquoi : les pages atteintes depuis plusieurs endroits (Réception depuis la
 * caisse OU depuis l'accueil tactile, Stocks depuis /welcome OU depuis /accueil)
 * avaient un bouton Retour câblé sur UNE destination fixe. Depuis l'accueil
 * tactile, « Mise en rayon » puis « Retour » renvoyait à la caisse, sans moyen
 * de revenir à l'accueil (signalé le 09/09/2026).
 *
 * `navigate(-1)` seul ne suffit pas : ouverte directement (icône d'écran
 * d'accueil, nouvel onglet, lien collé), la page n'a rien derrière elle et le
 * bouton ne ferait rien. React Router numérote les entrées qu'il crée
 * (`history.state.idx`, 0 = première page de la session) : au-dessus de 0, on
 * a bien une page de l'application derrière nous.
 */
export function useSmartBack(fallback: string) {
  const navigate = useNavigate();
  return useCallback(() => {
    const state = window.history.state as { idx?: unknown } | null;
    const idx = state && typeof state.idx === 'number' ? state.idx : 0;
    if (idx > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  }, [navigate, fallback]);
}
